import { render, staticRenderFns } from "./NetIncomeKPM.vue?vue&type=template&id=3c048db8"
import script from "./NetIncomeKPM.vue?vue&type=script&lang=js"
export * from "./NetIncomeKPM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports